
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Bestcabserviceinpune() {



    const cardData =
    {
        keyword: 'Best Cab Service in Pune',
        heading: 'Platinum24 Cabs: Best Cab Service in Pune',
        headingDescription: 'Platinum24 Cabs is recognized as the Best Cab Service in Pune, offering reliable and affordable travel solutions for every occasion. Whether it’s a short city ride, airport transfer, corporate travel, or outstation journey, our fleet of clean and well-maintained hatchbacks, sedans, SUVs, and luxury cars ensures maximum comfort. With experienced chauffeurs, timely pickups, and transparent fares, we provide a stress-free travel experience tailored to your needs. Trusted by families, professionals, and tourists alike, Platinum24 Cabs guarantees safety, punctuality, and unmatched service standards across Pune and beyond',

        top: 'Top Places to Visit in Pune with Platinum24 Cabs',

        "topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Built in 1732 by the Peshwas, Shaniwar Wada is Pune’s most iconic fort palace and a proud symbol of Maratha heritage. Its massive gates, fountains, and courtyards echo tales of the Maratha Empire. Though partially destroyed by fire in 1828, it still attracts thousands of tourists daily. The light-and-sound show narrates the story of Bajirao and Mastani. Visitors enjoy exploring its ruins and lush gardens. Shaniwar Wada is Pune’s cultural crown jewel."
  },
  {
    "title": "Aga Khan Palace",
    "description": "The Aga Khan Palace, built in 1892, is an important landmark in India’s freedom struggle. Mahatma Gandhi, Kasturba Gandhi, and other leaders were imprisoned here during the Quit India Movement. Today, it houses a museum displaying Gandhi’s personal belongings and photographs. The palace’s Italian arches and sprawling gardens make it a peaceful retreat. Tourists admire both its historic and architectural significance. Aga Khan Palace is Pune’s proud heritage of patriotism."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort, located 25 km from Pune, is a hill fortress famous for the 1670 battle where Tanaji Malusare fought for Chhatrapati Shivaji Maharaj. Trekkers climb the rugged paths for panoramic views of the Sahyadri ranges. The fort’s gates, bastions, and temples narrate stories of bravery. Monsoon brings mist, greenery, and waterfalls, making it especially scenic. Local vendors serve traditional pithla-bhakri at the top. Sinhagad Fort is Pune’s perfect blend of history and adventure."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "The Shreemant Dagdusheth Halwai Ganpati Temple is Pune’s most revered shrine dedicated to Lord Ganesha. Established over 125 years ago, the grand idol adorned with gold ornaments is a divine sight. During Ganesh Chaturthi, the temple becomes the epicenter of celebrations, attracting lakhs of devotees. The temple is also known for its charitable and cultural initiatives. Its spiritual aura makes it a must-visit for pilgrims and tourists. Dagdusheth is Pune’s divine cultural heart."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple, carved in the 8th century, is a rock-cut shrine dedicated to Lord Shiva. Its massive stone pillars, sanctum, and Nandi mandapa showcase ancient Indian craftsmanship. Located in the heart of the city, it offers peace and spiritual calm amidst urban chaos. Evening prayers add to its mystical atmosphere. History enthusiasts admire its simple yet powerful design. Pataleshwar is Pune’s hidden gem of spirituality and heritage."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "The Raja Dinkar Kelkar Museum is a cultural treasure housing over 20,000 artifacts collected by Dr. Dinkar Kelkar. It includes ornaments, sculptures, musical instruments, and household antiques. A highlight is the recreated Mastani Mahal, reflecting the Maratha era’s grandeur. Students and art lovers find it educational and fascinating. The museum preserves India’s traditions under one roof. It is Pune’s proud showcase of history and culture."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill, one of Pune’s oldest landmarks, offers panoramic views of the city. The hilltop temple complex, built by the Peshwas, is dedicated to Lord Shiva and Goddess Parvati. Smaller shrines and a museum add to its heritage significance. Visitors climb 103 steps to reach the temple, combining devotion with scenic charm. Sunrises and sunsets from the top are breathtaking. Parvati Hill is Pune’s sacred and scenic retreat."
  },
  {
    "title": "Osho Ashram",
    "description": "The Osho International Meditation Resort in Koregaon Park is a global center for spirituality and wellness. Spread across lush gardens, it attracts seekers from all over the world. The ashram offers meditation, yoga, and personal growth workshops. Japanese Zen gardens and serene meditation halls enhance the experience. It is both a wellness retreat and a spiritual destination. Osho Ashram is Pune’s international hub of peace and mindfulness."
  },
  {
    "title": "Pu La Deshpande Garden",
    "description": "Pu La Deshpande Garden, inspired by Japan’s Korakuen Garden, is Pune’s largest landscaped park. With flowing streams, stone bridges, and manicured lawns, it is a favorite for families and nature lovers. Seasonal flowers and lush greenery make it picturesque year-round. Families enjoy picnics, photography, and peaceful strolls here. It also symbolizes Indo-Japanese cultural friendship. Pu La Deshpande Garden is Pune’s green paradise of beauty and calm."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, built on the Mutha River, is a popular weekend retreat near Pune. It supplies water to the city while offering scenic views of hills and flowing waters. During monsoon, the overflowing dam creates a spectacular sight. Families enjoy roadside snacks like roasted corn and hot tea here. It is also the gateway to Sinhagad Fort treks. Khadakwasla is Pune’s refreshing natural escape for families and travelers alike."
  }
],



         "services": [
    {
      "name": "Reliable Cab Service Pune",
      "description": "Experience punctuality, safety, and comfort with our Reliable Cab Service in Pune. We prioritize on-time pickups, professional drivers, and well-maintained vehicles to ensure your journeys—whether local or outstation—are hassle-free. Ideal for daily commuters, tourists, and business travelers looking for trustworthy transportation."
    },
    {
      "name": "Affordable Best Cabs in Pune",
      "description": "Get the best value for your money with Affordable Best Cabs in Pune, offering competitive pricing without compromising on quality or safety. Our fleet includes economy and mid-range cars perfect for budget-conscious travelers who want dependable service for local trips, airport transfers, and outstation rides."
    },
    {
      "name": "Luxury Cab Service Pune",
      "description": "Travel in style and sophistication with our Luxury Cab Service in Pune, featuring premium vehicles equipped with plush interiors, climate control, and the latest amenities. Perfect for weddings, corporate travel, or special occasions when comfort and elegance matter the most."
    },
    {
      "name": "Pune Best Car Service",
      "description": "Our Pune Best Car Service stands out for its commitment to customer satisfaction, offering a wide variety of well-maintained cars, timely pickups, and professional drivers. Whether you need airport transfers, city travel, or outstation trips, we deliver excellence every step of the way."
    },
    {
      "name": "Highly Rated Cab Service Pune",
      "description": "Choose the Highly Rated Cab Service in Pune trusted by thousands for excellent customer reviews, safe driving standards, and friendly service. We provide transparent pricing, flexible booking options, and a wide selection of vehicles to cater to every travel need with utmost professionalism."
    },
    {
      "name": "Pune Best Taxi Booking",
      "description": "Book the best taxis in Pune with our easy-to-use platform, providing instant confirmation and access to top-rated drivers. Our service ensures comfort, affordability, and safety for every journey—whether it’s a quick city ride or a long-distance trip."
    },
    {
      "name": "Top-Rated Cab Service Pune",
      "description": "Our Top-Rated Cab Service Pune is recognized for excellence in punctuality, vehicle quality, and driver professionalism. With a customer-centric approach, we guarantee smooth rides across Pune and beyond, backed by glowing reviews and repeat clientele."
    },
    {
      "name": "Pune Elite Taxi Service",
      "description": "For those seeking premium transportation, our Pune Elite Taxi Service offers luxury vehicles, highly trained chauffeurs, and personalized travel experiences. Perfect for business executives, VIP guests, and special events where exclusivity and class are paramount."
    },
    {
      "name": "Best 24/7 Cab Service Pune",
      "description": "Our Best 24/7 Cab Service in Pune provides round-the-clock availability, ensuring you have reliable transport at any hour. Whether it’s early morning flights or late-night returns, our dedicated team and fleet are ready to serve you promptly and safely."
    },
    {
      "name": "Pune Premium Taxi Service",
      "description": "Offering premium taxi services in Pune with a focus on luxury, comfort, and reliability. Our well-maintained fleet includes high-end sedans and SUVs, suitable for corporate travel, weddings, or personal outings that demand an elevated travel experience."
    },
    {
      "name": "Best Pune Taxi Providers",
      "description": "Partner with the Best Pune Taxi Providers known for their extensive fleets, experienced drivers, and customer-first approach. We cover local commutes, airport transfers, and outstation journeys with competitive rates and exceptional service standards."
    },
    {
      "name": "Recommended Cab Service Pune",
      "description": "Highly Recommended Cab Service in Pune offering dependable rides, transparent pricing, and courteous drivers. Whether it’s for daily transportation, airport transfers, or leisure trips, our clients trust us for punctuality and professionalism every time."
    },
    {
      "name": "Best cab service in Pune",
      "description": "Experience the best cab service in Pune with a combination of affordability, safety, and quality. Our fleet is regularly maintained, and our drivers are trained to provide courteous and secure rides within Pune city and to nearby destinations."
    },
    {
      "name": "Best Cab Service Pune to Mumbai",
      "description": "Travel between Pune and Mumbai with the best cab service, featuring comfortable vehicles, experienced drivers, and competitive fares. Ideal for business commuters, tourists, and daily travelers seeking a smooth, timely journey on this popular route."
    },
    {
      "name": "Best Outstation Cab Service in Pune",
      "description": "Our Best Outstation Cab Service in Pune specializes in long-distance travel, ensuring safe, comfortable rides to popular destinations across Maharashtra and neighboring states. With flexible packages and professional drivers, we make your outstation trips stress-free."
    },
    {
      "name": "Best Taxi Service in Pune",
      "description": "Providing the best taxi service in Pune with punctual pickups, clean vehicles, and courteous drivers. We cater to all travel needs, including local rides, airport transfers, and outstation journeys, delivering excellent value and customer satisfaction."
    },
    {
      "name": "Best cab service Mumbai to Pune",
      "description": "Choose the best cab service from Mumbai to Pune, offering reliable, comfortable, and affordable rides. Our drivers are familiar with the route and traffic conditions to ensure timely arrivals and pleasant travel experiences for all passengers."
    },
    {
      "name": "Best cab service from Mumbai Airport to Pune",
      "description": "Our best cab service from Mumbai Airport to Pune provides seamless airport transfers with fixed pricing, courteous drivers, and spacious vehicles to accommodate your luggage and group comfortably, making your arrival or departure stress-free."
    },
    {
      "name": "Best Cab Service from Pune to Goa",
      "description": "Plan your trip to Goa with the best cab service from Pune, featuring well-maintained cars and expert drivers familiar with the scenic route. Enjoy comfortable, safe, and timely travel for holidays, business trips, or leisure getaways."
    },
    {
      "name": "Best Cab Service from Pune to Mumbai Airport",
      "description": "Reliable and timely cab service from Pune to Mumbai Airport, ensuring you reach your flight on time in a clean, comfortable vehicle. Our drivers assist with luggage and provide courteous service tailored for stress-free airport transfers."
    },
    {
      "name": "Best Mumbai Pune cab service",
      "description": "Offering the best cab service for Mumbai to Pune travelers with a focus on safety, punctuality, and competitive pricing. Ideal for frequent commuters and tourists who demand reliability and comfort in their intercity journeys."
    },
    {
      "name": "Best Pune to Mumbai cab service",
      "description": "Our Best Pune to Mumbai cab service guarantees a smooth, safe ride with professional drivers and a fleet of clean vehicles. Perfect for business travelers, families, and individuals needing efficient and affordable transportation between these two major cities."
    }
  ],
  "tableData": [
    ["Reliable Cab Service Pune", "Affordable Best Cabs in Pune"],
    ["Luxury Cab Service Pune", "Pune Best Car Service"],
    ["Highly Rated Cab Service Pune", "Pune Best Taxi Booking"],
    ["Top-Rated Cab Service Pune", "Pune Elite Taxi Service"],
    ["Best 24/7 Cab Service Pune", "Pune Premium Taxi Service"],
    ["Best Pune Taxi Providers", "Recommended Cab Service Pune"],
    ["Best cab service in Pune", "Best Cab Service Pune to Mumbai"],
    ["Best Outstation Cab Service in Pune", "Best Taxi Service in Pune"],
    ["Best cab service Mumbai to Pune", "Best cab service from Mumbai Airport to Pune"],
    ["Best Cab Service from Pune to Goa", "Best Cab Service from Pune to Mumbai Airport"],
    ["Best Mumbai Pune cab service", "Best Pune to Mumbai cab service"]
  ],


     "whychoose": [
    {
        "WhyChooseheading": "The Best Cab Service in Pune at Affordable Rates",
        "WhyChoosedescription": "Platinum24 Cabs is known for providing top-quality cab services in Pune with competitive pricing and excellent customer care."
    },
    {
        "WhyChooseheading": "Modern Fleet of Comfortable and Well-Maintained Cabs",
        "WhyChoosedescription": "Our vehicles are regularly serviced and cleaned to ensure a safe and pleasant travel experience."
    },
    {
        "WhyChooseheading": "Professional and Courteous Drivers",
        "WhyChoosedescription": "Our experienced drivers prioritize your safety and comfort, with thorough knowledge of Pune’s routes."
    },
    {
        "WhyChooseheading": "Easy and Convenient Booking Process",
        "WhyChoosedescription": "Book your cab effortlessly via phone, app, or website for quick and reliable service anytime."
    },
    {
        "WhyChooseheading": "Flexible Ride Options for All Your Needs",
        "WhyChoosedescription": "Choose from hourly rentals, full-day hires, airport transfers, and more, tailored to your schedule."
    },
    {
        "WhyChooseheading": "Transparent Pricing with No Hidden Fees",
        "WhyChoosedescription": "Enjoy clear, upfront pricing so you know exactly what you’re paying for, with no surprises."
    },
    {
        "WhyChooseheading": "Perfect for Personal, Family, and Corporate Travel",
        "WhyChoosedescription": "Our cab service caters to individual rides, group trips, and business travel across Pune."
    },
    {
        "WhyChooseheading": "24/7 Customer Support for a Hassle-Free Experience",
        "WhyChoosedescription": "Our dedicated support team is always ready to assist with bookings, cancellations, and queries."
    }
]













    }


const faqData = [
    {
        question: 'Why is Platinum24 Cabs considered the best cab service in Pune?',
        answer: 'Platinum24 Cabs is known for its reliable, affordable, and professional cab services with a fleet of well-maintained vehicles and experienced drivers.',
    },
    {
        question: 'What types of vehicles does Platinum24 Cabs offer in Pune?',
        answer: 'We offer a wide range of vehicles including hatchbacks, sedans, SUVs, and luxury cars to meet diverse customer needs.',
    },
    {
        question: 'How does Platinum24 Cabs ensure customer safety in Pune?',
        answer: 'All our vehicles are sanitized regularly, and drivers follow strict safety protocols. We also verify driver backgrounds for added security.',
    },
    {
        question: 'Are Platinum24 Cabs available for both local and outstation trips?',
        answer: 'Yes, we provide seamless cab services for local Pune travel as well as outstation trips to nearby cities and tourist destinations.',
    },
    {
        question: 'Can I book Platinum24 Cabs for corporate travel in Pune?',
        answer: 'Absolutely! We offer customized corporate travel solutions with priority support and flexible billing options.',
    },
    {
        question: 'How can I book the best cab service with Platinum24 Cabs?',
        answer: 'You can book easily via our website, mobile app, or by calling our 24/7 customer support for quick assistance.',
    },
    {
        question: 'Does Platinum24 Cabs offer competitive pricing in Pune?',
        answer: 'Yes, we provide transparent and competitive pricing with no hidden charges to give you the best value for your money.',
    },
    {
        question: 'Are there any discounts or loyalty programs available?',
        answer: 'Yes, we offer regular discounts and loyalty rewards for frequent travelers using Platinum24 Cabs in Pune.',
    },
    {
        question: 'How punctual are Platinum24 Cabs drivers in Pune?',
        answer: 'Our drivers are known for their punctuality, ensuring timely pickups and drop-offs for a hassle-free experience.',
    },
    {
        question: 'What makes Platinum24 Cabs stand out among other cab services in Pune?',
        answer: 'Our commitment to quality service, customer satisfaction, modern fleet, and professional drivers set us apart as the best cab service in Pune.',
    },
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Aditya Malhotra',
        feedback: 'Platinum24 Cabs truly lives up to its reputation as the best cab service in Pune. The cars are clean and the service is outstanding!',
        rating: 5,
    },
    {
        id: 2,
        name: 'Ms. Sneha Joshi',
        feedback: 'I have tried several cab services in Pune, but Platinum24 Cabs stands out for its professionalism and reliability. Highly recommended!',
        rating: 5,
    },
];





























    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "pune-cab-service" },
        { place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "pune-taxi-hire" },
        { place: "/images/keyword/3.jpg", text: "Pune Online Cab Booking", link: "pune-online-cab-booking" },
        { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "best-cab-service-in-pune" },
        { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cabs", link: "pune-to-mumbai-cabs" },
        { place: "/images/keyword/6.jpg", text: "Pune to Nashik Cabs", link: "pune-to-nashik-cabs" },
        { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "pune-to-mahabaleshwar-cabs" },
        { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cabs", link: "pune-to-lonavala-cabs" },
        { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
        { place: "/images/keyword/10.jpg", text: "Pune to Bhimashankar Cab", link: "pune-to-bhimashankar-cab" },
        { place: "/images/keyword/11.jpg", text: "Pune to Konkan Darshan Cabs", link: "pune-to-konkan-darshan-cabs" },
        { place: "/images/keyword/12.jpg", text: "Pune Outstation Cabs", link: "pune-outstation-cabs" },
        { place: "/images/keyword/13.jpg", text: "Ashtavinayak Darshan Cab", link: "ashtavinayak-darshan-cab" },
        { place: "/images/keyword/14.jpg", text: "Pune to Goa Cabs", link: "pune-to-goa-cabs" },
        { place: "/images/keyword/15.jpg", text: "Cabs Services Near Me", link: "cabs-services-near-me" },
        { place: "/images/keyword/16.jpg", text: "Corporate Cab Service in Pune", link: "corporate-cab-service-in-pune" },
        { place: "/images/keyword/17.jpg", text: "Pune to Mumbai Airport Cabs", link: "pune-to-mumbai-airport-cabs" },
        { place: "/images/keyword/18.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Pune", link: "urbania-on-rent-in-pune" },
        { place: "/images/keyword/20.jpg", text: "Innova Crysta On Rent in Pune", link: "innova-crysta-on-rent-in-pune" },
        { place: "/images/keyword/21.jpg", text: "Bus On Rent in Pimpri Chinchwad", link: "bus-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
        { place: "/images/keyword/23.jpg", text: "Ertiga On Rent in Pune", link: "ertiga-on-rent-in-pune" },
        { place: "/images/keyword/24.jpg", text: "Pune to Sambhaji Nagar Taxi", link: "pune-to-sambhaji-nagar-taxi" },
        { place: "/images/keyword/25.jpg", text: "Pune to Ganpatipule Taxi", link: "pune-to-ganpatipule-taxi" }
    ];









const bestCabServicePuneSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Best Cab Service in Pune",
  "image": "https://www.platinum24cab.com/assets/images/best-cab-service-pune.jpg",
  "description": "Looking for the best cab service in Pune? Platinum24 Cabs offers reliable, affordable, and luxury cab options for local, airport, and outstation travel. Top-rated service with 24/7 availability.",
  "brand": {
    "@type": "Brand",
    "name": "Platinum24 Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "38950",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "950",
    "availability": "https://schema.org/InStock",
    "url": "https://www.platinum24cab.com/best-cab-service-in-pune"
  }
};





    return (
        <div>
<Helmet>
  <title>Best Cab Service in Pune | Top-Rated Taxi Provider | Platinum24 Cabs</title>
  <meta
    name="description"
    content="Looking for the best cab service in Pune? Platinum24 Cabs offers reliable, affordable, and luxury cab options for local, airport, and outstation travel. Top-rated service with 24/7 availability."
  />
  <meta
    name="keywords"
    content="Reliable Cab Service Pune, Affordable Best Cabs in Pune, Luxury Cab Service Pune, Pune Best Car Service, Highly Rated Cab Service Pune, Pune Best Taxi Booking, Top-Rated Cab Service Pune, Pune Elite Taxi Service, Best 24/7 Cab Service Pune, Pune Premium Taxi Service, Best Pune Taxi Providers, Recommended Cab Service Pune, Best cab service in Pune, Best Cab Service Pune to Mumbai, Best Outstation Cab Service in Pune, Best Taxi Service in Pune, Best cab service Mumbai to Pune, Best cab service from Mumbai Airport to Pune, Best Cab Service from Pune to Goa, Best Cab Service from Pune to Mumbai Airport, Best Mumbai Pune cab service, Best Pune to Mumbai cab service"
  />
  <script type="application/ld+json">
    {JSON.stringify(bestCabServicePuneSchema)}
  </script>
</Helmet>


            <div
                className="breadcumb-wrapper"
                // style={{ backgroundImage: "url('/img/breadcumb/breadcumb-bg.jpg')" }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                        <div className="breadcumb-menu-wrap">
                        </div>
                    </div>
                </div>
            </div>










            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/4.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>
                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        <div className="service-icon">
                                            🚖
                                        </div>
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Platinum24 Cabs</span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Platinum24 Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+917507048333" className="pc-call">+91 7507048333</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/917507048333"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+917507048333" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@platinum24cab.com" className="pc-email">
                                            booking@platinum24cab.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Platinum24 Cabs</strong><br />
                                            OFFICE NO.2, SECTOR NO.4, PLOT NO.295(S), SAI GANGA APARTMENT, ABOVE UMED ELECTRICAL, NEAR ACORD HOSPITAL
                                            FIRST FLOOR, SANT NAGAR, MOSHI, PUNE 412105
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Bestcabserviceinpune;